// extracted by mini-css-extract-plugin
export var legendIndicator = "_f9-1";
export var legendRight = "_f9-0";